import { createEntitySlice } from '@/shared/store/createEntitySlice';
import { deepLinksApi } from '../api';
import type { DeepLink, DeepLinkFilters, DeepLinkFormData } from '../types';

type DeepLinksListParams = {
  page: number;
  perPage: number;
  routingCode?: string;
  targetSystem?: string;
  isActive?: boolean;
};

export const DEEP_LINKS_DEFAULT_FILTERS: DeepLinkFilters = {
  search: '',
  dateRange: null,
  routingCode: '',
  targetSystem: '',
  isActive: '',
};

const initialState = {
  items: [] as DeepLink[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 10,
  total: 0,
  lastPage: 1,
  filters: DEEP_LINKS_DEFAULT_FILTERS,
};

const { actions, reducer } = createEntitySlice<DeepLink, DeepLinkFilters, DeepLinkFormData>({
  name: 'deepLinksEntity',
  api: deepLinksApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.deepLinksEntity;
    const params: DeepLinksListParams = { page: currentPage, perPage };

    if (filters.routingCode.trim()) {
      params.routingCode = filters.routingCode.trim();
    }

    if (filters.targetSystem) {
      params.targetSystem = filters.targetSystem;
    }

    if (filters.isActive !== '') {
      params.isActive = filters.isActive;
    }

    return params;
  },
});

export const {
  fetchItems: fetchDeepLinks,
  createItem: createDeepLink,
  updateItem: updateDeepLink,
  deleteItem: deleteDeepLink,
  setPage,
  setPerPage,
  setFilters,
} = actions;

export { reducer };
